import { defineStore } from 'pinia'
import { EventsV2Service } from '@/services/events-v2-service'
import type { EventResponse } from '@/services/events-v2-service/types'
import type { ApiError } from '@/utils/types'
import axios from 'axios'
import { FALLBACK_API_ERROR } from '@/utils/consts'

export const useEventsStore = defineStore('events', {
  state: () => ({
    loading: true,
    error: null as ApiError | null,
    events: [] as EventResponse[],
    pages: 1 as number,
  }),

  getters: {},

  actions: {
    async fetch() {
      this.loading = true
      try {
        const req = await EventsV2Service.fetchEvents()
        const data = req.data
        this.events = data.events ?? []
        this.pages = data.pages
      } catch (thrown) {
        if (axios.isAxiosError(thrown) && thrown.response) {
          this.error = {
            message: thrown.response?.data,
            code: thrown.response?.status,
          }
        } else {
          this.error = FALLBACK_API_ERROR
        }
      } finally {
        this.loading = false
      }
    },
  },
})
